export default __webpack_public_path__ + "static/media/MOH-logo.d50f7556.png";